export const sessionDetailsStaticData = {
  sessionText: 'Sessions',
  upcomingText: 'Upcoming',
  completedText: 'Completed',
  cancelledText: 'Cancelled',
  rescheduledText: 'Rescheduled',
  studentProfileText: 'Student Profile',
  detailsText: 'Details',
  rescheduleText: 'Reschedule',
  cancelSessionText: 'Cancel Session',
  sessionDetailsText: 'Session Detail',
  dateText: 'Date',
  timingText: 'Timing',
  subjectText: 'Subject',
  sessionTypeText: 'Session Type',
  studentQueriesText: 'Student Queries',
  documentText: 'Document',
  nameText: 'Name',
  languageText: 'Language',
  schoolNameText: 'School Name',
  genderText: 'Gender',
  ageText: 'Age',
  schoolLevelText: 'School Level',
  sessionDatesText: 'Session Dates',
  studentReviewText: 'Student Review',
  reportIssuesText: 'Report Issues',
  extendSessionText: 'Extend Session',
  cancellationDetailsText: 'Cancellation Details',
};

export const sessionDetailsHindiData = {
  sessionText: 'सत्र',
  upcomingText: 'आगामी',
  completedText: 'पूरा हुआ',
  cancelledText: 'रद्द किया गया',
  rescheduledText: 'पुनर्निर्धारित',
  studentProfileText: 'छात्र प्रोफ़ाइल',
  detailsText: 'विवरण',
  rescheduleText: 'पुनर्निर्धारित करें',
  cancelSessionText: 'सत्र रद्द करें',
  sessionDetailsText: 'सत्र विवरण',
  dateText: 'तारीख़',
  timingText: 'समय',
  subjectText: 'विषय',
  sessionTypeText: 'सत्र प्रकार',
  studentQueriesText: 'छात्र प्रश्न',
  documentText: 'दस्तावेज़',
  nameText: 'नाम',
  languageText: 'भाषा',
  schoolNameText: 'विद्यालय का नाम',
  genderText: 'लिंग',
  ageText: 'आयु',
  schoolLevelText: 'विद्यालय स्तर',
  sessionDatesText: 'सत्र तिथियाँ',
  studentReviewText: 'छात्र समीक्षा',
  reportIssuesText: 'समस्याओं की रिपोर्ट करें',
  extendSessionText: 'सत्र बढ़ाएं',
  cancellationDetailsText: 'रद्दीकरण विवरण',
};

export const sessionDetailsArabicData = {
  sessionText: 'الجلسات',
  upcomingText: 'القادمة',
  completedText: 'مكتملة',
  cancelledText: 'ملغاة',
  rescheduledText: 'مُعاد جدولتها',
  studentProfileText: 'ملف الطالب الشخصي',
  detailsText: 'التفاصيل',
  rescheduleText: 'إعادة جدولة',
  cancelSessionText: 'إلغاء الجلسة',
  sessionDetailsText: 'تفاصيل الجلسة',
  dateText: 'التاريخ',
  timingText: 'التوقيت',
  subjectText: 'المادة',
  sessionTypeText: 'نوع الجلسة',
  studentQueriesText: 'استفسارات الطالب',
  documentText: 'الوثيقة',
  nameText: 'الاسم',
  languageText: 'اللغة',
  schoolNameText: 'اسم المدرسة',
  genderText: 'الجنس',
  ageText: 'العمر',
  schoolLevelText: 'مستوى المدرسة',
  sessionDatesText: 'تواريخ الجلسات',
  studentReviewText: 'تقييم الطالب',
  reportIssuesText: 'الإبلاغ عن المشاكل',
  extendSessionText: 'تمديد الجلسة',
  cancellationDetailsText: 'تفاصيل الإلغاء',
};
